import { Reveal } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, titleItalic, description, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={`section-${eyebrow?.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
    <Reveal>
      <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-ember">
        <span className={`h-px w-8 bg-ember ${align === "center" ? "hidden" : ""}`} aria-hidden="true" />
        {eyebrow}
      </p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-5 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl">
        {title}{" "}
        {titleItalic && (
          <span className="font-editorial italic font-medium text-ember">{titleItalic}</span>
        )}
      </h2>
    </Reveal>
    {description && (
      <Reveal delay={0.16}>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-ash md:text-lg">{description}</p>
      </Reveal>
    )}
  </div>
);
